var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      staticClass: "sub-menu",
      staticStyle: { "margin-bottom": "15px" },
      attrs: {
        "slider-color": "primary",
        height: "64",
        "background-color": "transparent"
      }
    },
    [
      _vm.isLoaded
        ? [
            _vm.hasPermissionForDelegationTask &&
            _vm.$store.getters["userProperties"].system_settings
              .is_delegation_task_enabled === 2
              ? _c(
                  "v-tab",
                  {
                    staticClass: "sub-menu-item",
                    attrs: { to: "/delegation-info/delegation-task" }
                  },
                  [
                    _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                      _vm._v("assignment")
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("delegationInfoMenu.delegationTask")) +
                        " "
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.hasPermissionForVehicles
              ? _c(
                  "v-tab",
                  {
                    staticClass: "sub-menu-item",
                    attrs: { to: "/delegation-info/vehicle" }
                  },
                  [
                    _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                      _vm._v("directions_car")
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("delegationInfoMenu.vehicle")) + " "
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "v-tab",
              {
                staticClass: "sub-menu-item",
                attrs: { to: "/delegation-info/exchange-rate" }
              },
              [
                _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                  _vm._v("attach_money")
                ]),
                _vm._v(
                  " " + _vm._s(_vm.$t("delegationInfoMenu.exchangeRate")) + " "
                )
              ],
              1
            ),
            _vm.hasPermissionForDelegationRate
              ? _c(
                  "v-tab",
                  {
                    staticClass: "sub-menu-item",
                    attrs: { to: "/delegation-info/delegation-rate" }
                  },
                  [
                    _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                      _vm._v("account_balance")
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("delegationInfoMenu.delegationRates")) +
                        " "
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._l(_vm.customWebpages, function(customWebpage) {
              return _c(
                "v-tab",
                {
                  key: customWebpage.id,
                  staticClass: "sub-menu-item",
                  attrs: { to: "/delegation-info/" + customWebpage.alias }
                },
                [
                  _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                    _vm._v(_vm._s(customWebpage.icon))
                  ]),
                  _vm._v(" " + _vm._s(customWebpage.title) + " ")
                ],
                1
              )
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }